import { render, staticRenderFns } from "./ReferenceGroupsRow.vue?vue&type=template&id=90675ec2&scoped=true&"
import script from "./ReferenceGroupsRow.vue?vue&type=script&lang=js&"
export * from "./ReferenceGroupsRow.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceGroupsRow.vue?vue&type=style&index=0&id=90675ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90675ec2",
  null
  
)

export default component.exports